import axios from 'axios';
import UserAuthentication from '@app/Security/UserAuthentication';

/**
 * Add an intercepter to check for unauthorized response (401)
 * see: https://axios-http.com/docs/interceptors
 */
axios.interceptors.response.use(
    response => response,
    async error => {

        const { status, data } = error.response;
        const { url } = error.config;
        const isLoginPage = String(url).endsWith("/login");

        if (status === 401 && !isLoginPage) {
            await UserAuthentication.logout(true);
            window.location.href = "/";
        } else if (status == 500 && isLoginPage) {

            const dataString = JSON.stringify(data);
            const isUnconfirmed = dataString?.includes("User is not registered") ?? false;

            if (isUnconfirmed) {
                return Promise.reject("Unconfirmed");
            }

        }

        return Promise.reject(error);
    }
);

export default axios;